import { fnBisAdmin, fnBIsConsultant, fnCanAtLeast, fnUserCtype } from "./permissions"

const permitions = [
  "access-ciq",
  "create-edit-analyte",
  "create-edit-equipment",
  "create-edit-control",
  "create-edit-launch",
  "update-run",
]

export const fnVerifyPermission = () => {
  let result = []

  for (let i = 0; i < permitions.length; i++) {
    result.push({
      permition: permitions[i],
      isPermition: fnCanAtLeast(permitions[i], "internal-quality-control"),
    })
  }

  return result
}

export const fnisOnlyPermition = (permition) => {
  return fnVerifyPermission().every(
    (permission) =>
      (permission.permition === permition && permission.isPermition) ||
      !permission.isPermition,
  )
}

export const fnIsAccessPermition = (myPermition) => {
  return fnVerifyPermission().some(
    (permission) => permission.permition === myPermition && permission.isPermition,
  )
}

export const fnMoreThanOnePermition = () => {
  return fnVerifyPermission().filter((permission) => permission.isPermition).length > 1
}

export const fnCanExportBoard = () => {
  if (!fnUserCtype(["Consultoria", "Certificadora"])) return false
  return fnCanAtLeast("create-edit-board")
}
